__turbopack_context__.v({
  "loadingShell": "games-module-scss-module__gYEkUG__loadingShell",
});
